import api from "./api";

export default class ClienteCoresLogoApi {
  static getCoresLogo = async (id: number) => {
    const response = await api.get(`/ClienteCoresLogo/${id}`);
    return response.data;
  };

  static getCoresLogoAntesDeLogar = async (hashString: string) => {
    const response = await api.get(`/ClienteCoresLogo/secret/${hashString}`);
    return response.data;
  };

}